//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

import TabelaGenerica from '../../../../shared-components/generico/TabelaGenerica';
import exportacao from '../../../../common/resources/exportacoes';
import { getMoney, getNumber } from '../../../../common/functions/helpers';
import UploadFile from '../../../../shared-components/upload/UploadFile';
import MargemContribuicaoSidebar from './MargemContribuicaoSidebar';

export default {
  extends: TabelaGenerica,
  name: 'MargemContribuicao',
  data() {
    return {
      resources: this.$api.margemcontribuicao(this.$resource),
      esperar: true,
      pagination: {
        itemsPerPage: 10,
      },
      totalPage: 0,

      headers: [
        { text: 'Ano', align: 'center', sortable: false, value: 'ano' },
        { text: 'Mes', sortable: false, value: 'mes' },
        { text: 'Código do produto', sortable: false, value: 'codigoProduto' },
        { text: 'Nome do produto', sortable: false, value: 'nomeProduto' },
        { text: 'Código do cliente', sortable: false, value: 'codigoCliente' },
        { text: 'Nome do cliente', sortable: false, value: 'nomeCliente' },
        { text: 'Volume Vendido (Kg)', sortable: false, value: 'volumeVendido' },
        { text: 'Faturamento liquido', sortable: false, value: 'faturamentoLiquido' },
        { text: 'Custo total', sortable: false, value: 'custoTotal' },
        { text: 'Canal', sortable: false, value: 'canal' },
        { text: 'Holding', sortable: false, value: 'holding' },
      ],
      margens: [],
    };
  },
  components: {
    MargemContribuicaoSidebar,
    UploadFile,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      return this.getAllRoles.indexOf('MARGEM_ROI') >= 0;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.requestPopularMargens();
      },
      deep: true,
    },
    searchQuery() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.paginationPage = 0;
        this.requestPopularMargens();
      }, 500);
    },
  },
  methods: {
    getMoney,
    getNumber,
    openSideBar() {
      this.$refs.sidebar.open();
    },
    requestPopularMargens() {
      const filtros = {
        numeroPagina: this.pagination.page,
        tamanhoPagina: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };
      if (this.searchQuery !== '') {
        filtros.filtro = this.searchQuery;
      }
      this.resources.listar(filtros).then((response) => {
        this.margens = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.esperar = false;
      })
      .catch((err) => {
        this.esperar = false;
        this.$error(this, err);
      });
    },
    exportarFiltros(filtros, cb, nomeExportador, limit = 500, timeout = 120000) {
      const resource = exportacao(this.$http, timeout);
      resource.download(nomeExportador,
        {
          limit,
          parametrosConsulta: filtros,
        })
        .then(() => {
          this.$toast.create(this.$t('message.exportacao_download'), 'snack', 3E3);
        })
        .catch(() => {
          this.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
        });
    },
    requestExportacao(cb) {
      this.exportar(cb, 'margem_contribuicao');
    },
    exportar(cb, nomeExportador, limit = 500, timeout = 120000) {
      const filtros = {
        filtro: this.searchQuery,
      };
      this.exportarFiltros(filtros, cb, nomeExportador, limit, timeout);
    },
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
      }
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
    this.requestPopularMargens();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/margem-roi/MargemContribuicao.vue?vue&type=script&lang=js&